export enum InputPresetId {
    Custom = 'custom',
    Revit = 'revit',
    AutoCad = 'autocad',
    Empty = 'empty'
}
